/**
Author - Sahil Dhingra
Git - https://github.com/sahildhingra-221
**/

import React from "react";

import {WealthyEnv} from "helpers";

import WhyWealthyBroking from "./WhyWealthyBroking";

const WhyWealthyBrokingContainer = ({partnerData}) => {
  const featuresList = [
    {
      name: "Wealthy Ideas",
      info: "Curated stock baskets | Helpful for beginners"
    },
    {
      name: "Unbeatable Pricing",
      info: "Minimal Brokerage",
      url: `${WealthyEnv.URL}/pricing`,
      urlText: "Pricing Details"
    },
    {
      name: "Family Account Feature",
      info: "Add upto 10 members | Invest for your family"
    },
    {
      name: "Seamless Trading Experience",
      info: "Fast and efficient | Quick trade execution"
    },
    {
      name: "Super app with multiple Products.",
      info: "Multiple financial products | One app for all financial needs"
    }
  ];

  return (
    <WhyWealthyBroking featuresList={featuresList} partnerData={partnerData} />
  );
};

export default WhyWealthyBrokingContainer;
